import React from 'react'
import './ProjectNotFoundPopup.css'
import WaitingLoaders from '../Loaders/WaitingLoaders'

const ProjectNotFoundPopup = (props) => {
    const { isLoading, currentOrgPlan } = props

    if (isLoading) {
        return <WaitingLoaders show={true} size={60} />
    }
    return (
        <div className="project-not-found-container">
            <div className="project-not-found-header">
                <h2 className="project-not-found-title">{`${currentOrgPlan === 'LEARNER' ? 'Practice' : 'Project'} Not Found`}</h2>
            </div>

            <div className="project-not-found-content">
                <p className="project-not-found-message">
                    The project you’re trying to access may have been deleted or you don’t have access to it.
                </p>

                <p className="project-not-found-message">
                    Don't worry — we'll take you to your default project so you can continue working without interruption.
                </p>

                <p className="project-not-found-question">
                    Would you like to continue?
                </p>
            </div>
        </div>
    )
}

export default ProjectNotFoundPopup
